import { IconButton, Tooltip, Typography } from '@material-ui/core';
import { useRef, useState, useEffect, useMemo } from 'react';
import BreadCrumb from '../../../component/BreadCrumb';
import { CODE_GROUP_ID, ENROLMENT_SEARCH_SUBJECT_PATH } from '../../../constant/Constant';
import CodeUtil from '../../../util/CodeUtil';
import PopupRef from '../../../component/PopupRef';
import SemesterStudentUniversityModal from '../../modal/SemesterStudentUniversityModal';
import { modalType } from '../../../util/ModalUtil';
import ModalRef from '../../../component/ModalRef';
import SelectionBox from '../../../component/SelectionBox';
import DeleteIcon from '../../../component/icon/DeleteIcon';
import TableBox from '../../../component/TableBox';
import { useDispatch, useSelector } from 'react-redux';
import {
    actionEditUserRegValidStatusCd,
    actionSearch,
    actionRemove,
    actionExcelDownload,
} from '../../../module/body/semester/SemesterStudentUniversityModule';
import { VIEW_SEMESTER_STUDENT_UNIVERSITY } from './../../../constant/ViewConstant';
import InputBox from '../../../component/InputBox';
import SearchButtonBox from '../../../component/buttons/SearchButtonBox';
import AuthenticationUtil from '../../../util/AuthenticationUtil';

// toggle button
import RemoveIcon from '@material-ui/icons/Remove';
import DoneIcon from '@material-ui/icons/Done';
import PauseIcon from '@material-ui/icons/Pause';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import SessionStorageUtil from '../../../util/SessionStorageUtil';
import PostAddIcon from '@material-ui/icons/PostAdd';
import NullCheckUtil from '../../../util/NullCheckUtil';
import FormatUtil from '../../../util/FormatUtil';

import { handleControl, defaultGridData, handleGridData, initGrid } from '../../../module/component/TableBoxModule';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import PathUtil from '../../../util/PathUtil';
import { OpenEditIcon } from '../../../component/icon/GridIcons';
import ExcelDownloadButtonBox from '../../../component/buttons/ExcelDownloadButtonBox';
import qs from 'qs';
import { Link } from '@mui/material';
import RegSemesterListModal from '../../modal/RegSemesterListModal';

const ConditionArea = ({ popupRef, modalRef }) => {
    const location = useLocation();
    const queryData = qs.parse(location.search, { ignoreQueryPrefix: true });
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const mainUniversityCd = AuthenticationUtil.getUserUniversityCd();
    const [userUniversityCd, setUserUniversityCd] = useState('');
    const semesterId = SessionStorageUtil.getCurrentSemesterId();
    const [userRegValidStatusCd, setUserRegValidStatusCd] = useState('');
    const [userNm, setUserNm] = useState('');
    const [params, setParams] = useState({});

    const { gridData } = useSelector((state) => state.tableBoxState);

    useEffect(() => {
        dispatch(
            handleControl({
                columns,
                onRowDoubleClick,
                onChangePageInfo,
                params,
            }),
        );

        queryData.userRegValidStatusCd && setUserRegValidStatusCd(queryData.userRegValidStatusCd);
        queryData.userNm && setUserNm(queryData.userNm);

        onClickSearch({
            mainUniversityCd,
            userUniversityCd,
            userRegValidStatusCd: queryData.userRegValidStatusCd,
            userNm: queryData.userNm,
            page: NullCheckUtil.isNotNull(queryData.page) ? queryData.page : defaultGridData.page,
            pageSize: NullCheckUtil.isNotNull(queryData.pageSize) ? queryData.pageSize : 100,
        });

        return () => {
            dispatch(initGrid());
        };
    }, []);

    useEffect(() => {
        dispatch(
            handleControl({
                columns,
                onRowDoubleClick,
                onChangePageInfo,
                params,
            }),
        );
    }, [params]);

    const onChangePageInfo = (page, pageSize) => {
        onClickSearch({
            ...params,
            page,
            pageSize,
        });
    };

    const onClickSearch = (params) => {
        setParams(params);
        dispatch(
            actionSearch({
                params,
                callback: (result) => {
                    if (result.totalCount == 0) {
                        popupRef.current.openAlert('조회된 결과가 없습니다.');
                    }
                },
            }),
        );
        PathUtil.pushState(location.pathname, params);
    };

    const onRowDoubleClick = (row, params) => {
        modalRef.current.open(
            <SemesterStudentUniversityModal
                type={modalType.EDIT}
                row={row}
                modalRef={modalRef}
                popupRef={popupRef}
                callback={() => {
                    onClickSearch(params);
                }}
            />,
            'medium',
        );
    };

    const onClickSemesterCnt = (row) => {
        modalRef.current.open(
            <RegSemesterListModal
                row={row}
                type={modalType.DETAIL}
                modalRef={modalRef}
                callback={() => {
                    onClick(row.userId);
                }}
            />,
            'small',
        );
    };

    const handleUserRegValidStatusCd = (row, newValue, params) => {
        if (NullCheckUtil.isNotEmpty(newValue)) {
            dispatch(
                actionEditUserRegValidStatusCd({
                    data: { userId: row.userId, semesterId, userRegValidStatusCd: newValue, force: false },
                    callback: () => {
                        onClickSearch(params);
                    },
                }),
            );
        }
    };

    const onKeyDown = (e) => {
        if (e.key == 'Enter') {
            onClickSearch({
                mainUniversityCd,
                userUniversityCd,
                userRegValidStatusCd,
                userNm,
                page: defaultGridData.page,
                pageSize: gridData.pageSize,
            });
        }
    };

    // grid action - delete
    const handleDelete = (row, params) => {
        popupRef.current.openWarning('사용자 [' + row.userNm + '](를)을 삭제하시겠습니까?', () => {
            return function () {
                dispatch(
                    actionRemove({
                        data: { userId: row.userId, semesterId },
                        callback: () => {
                            onClickSearch(params);
                        },
                    }),
                );
            };
        });
    };

    const handleMoveEnrolment = (row) => {
        const path = PathUtil.pushState(ENROLMENT_SEARCH_SUBJECT_PATH, {
            userId: row.userId,
            userNm: row.userNm,
            userUniversityCd: row.userUniversityCd,
        });
        navigate(path);
    };

    const handleDownload = () => {
        dispatch(actionExcelDownload({ params }));
    };

    const columns = useMemo(
        () => [
            {
                field: 'userUniversityNm',
                headerName: '소속대학',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },
            {
                field: 'majorDeptNm',
                headerName: '전공(학과)',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },
            {
                field: 'studentId',
                headerName: '학번',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },
            {
                field: 'userNm',
                headerName: '이름',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },
            {
                field: 'userId',
                headerName: '사용자ID',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },
            {
                field: 'telNo',
                headerName: '연락처',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
                renderCell: (params) => FormatUtil.phoneFormatter(params.row.telNo),
            },
            {
                field: 'userRegValidStatusCd',
                headerName: '본교가입검증',
                headerAlign: 'center',
                align: 'center',
                // tooltip: true,
                flex: 10,
                renderCell: (item) => (
                    <ToggleButtonGroup
                        size='small'
                        value={item.row.userRegValidStatusCd}
                        exclusive
                        onChange={(e, newValue) => handleUserRegValidStatusCd(item.row, newValue, params)}
                    >
                        <ToggleButton
                            value='WAITING'
                            aria-label={CodeUtil.getCodeName(CODE_GROUP_ID.USER_REG_VALID_STATUS, 'WAITING')}
                            size='small'
                        >
                            <Tooltip title={CodeUtil.getCodeName(CODE_GROUP_ID.USER_REG_VALID_STATUS, 'WAITING')}>
                                <RemoveIcon fontSize='small' />
                            </Tooltip>
                        </ToggleButton>
                        <ToggleButton
                            value='CONFIRM'
                            aria-label={CodeUtil.getCodeName(CODE_GROUP_ID.USER_REG_VALID_STATUS, 'CONFIRM')}
                            size='small'
                        >
                            <Tooltip title={CodeUtil.getCodeName(CODE_GROUP_ID.USER_REG_VALID_STATUS, 'CONFIRM')}>
                                <DoneIcon fontSize='small' />
                            </Tooltip>
                        </ToggleButton>
                        <ToggleButton
                            value='HOLD'
                            aria-label={CodeUtil.getCodeName(CODE_GROUP_ID.USER_REG_VALID_STATUS, 'HOLD')}
                            size='small'
                        >
                            <Tooltip title={CodeUtil.getCodeName(CODE_GROUP_ID.USER_REG_VALID_STATUS, 'HOLD')}>
                                <PauseIcon fontSize='small' />
                            </Tooltip>
                        </ToggleButton>
                    </ToggleButtonGroup>
                ),
            },
            {
                field: 'regSemesterCnt',
                headerName: '등록학기수',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 6,
                renderCell: (item) =>
                    item.row.regSemesterCnt == 0 ? (
                        <>{item.row.regSemesterCnt}</>
                    ) : (
                        <Link
                            component='button'
                            onClick={(e) => {
                                onClickSemesterCnt(item.row);
                            }}
                        >
                            {item.row.regSemesterCnt}
                        </Link>
                    ),
            },
            {
                field: 'regDttm',
                headerName: '가입일자',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                // type: "dateTime",
                // editable: true,
                flex: 10,
            },
            {
                field: 'detail',
                headerName: '기능',
                headerAlign: 'center',
                align: 'center',
                flex: 15,
                disableColumnMenu: true,
                hideSortIcons: true,
                disableExport: true,
                renderCell: (item) => (
                    <>
                        <Tooltip title='수정'>
                            <IconButton onClick={() => onRowDoubleClick(item.row, params)}>
                                <OpenEditIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title='삭제'>
                            <IconButton onClick={(e) => handleDelete(item.row, params)}>
                                <DeleteIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title='수강신청'>
                            <IconButton onClick={(e) => handleMoveEnrolment(item.row)}>
                                <PostAddIcon />
                            </IconButton>
                        </Tooltip>
                    </>
                ),
            },
        ],
        [params],
    );

    return (
        <>
            <div className='con-form-wrap '>
                <div className='board-inner'>
                    <div className='board-row'>
                        <div className='lec-check-box'>
                            <div className='search-condition-box'>
                                <div className='form-box-container'>
                                    <SelectionBox
                                        title='소속대학'
                                        w140
                                        value={userUniversityCd}
                                        options={CodeUtil.getCodes(CODE_GROUP_ID.USER_UNIVERSITY)}
                                        onChange={(e) => setUserUniversityCd(e.target.value)}
                                        onKeyDown={(e) => onKeyDown(e)}
                                    />
                                    <SelectionBox
                                        title='본교가입검증'
                                        w140
                                        value={userRegValidStatusCd}
                                        options={CodeUtil.getCodes(CODE_GROUP_ID.USER_REG_VALID_STATUS)}
                                        onChange={(e) => setUserRegValidStatusCd(e.target.value)}
                                        onKeyDown={(e) => onKeyDown(e)}
                                    />
                                    <InputBox
                                        title='이름'
                                        value={userNm}
                                        onChange={(e) => setUserNm(e.target.value)}
                                        onKeyDown={(e) => onKeyDown(e)}
                                    />
                                </div>
                            </div>
                            <div className='lec-check-btn'>
                                <SearchButtonBox
                                    title='조회'
                                    onClick={(e) =>
                                        onClickSearch({
                                            mainUniversityCd,
                                            userUniversityCd,
                                            userRegValidStatusCd,
                                            userNm,
                                            page: defaultGridData.page,
                                            pageSize: gridData.pageSize,
                                        })
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='con-tb-wrap'>
                <div className='con-tb-title'>
                    <h3 className='tb-tit-name'>본교학생 가입 목록</h3>
                    <div className='btn-group'>
                        <ExcelDownloadButtonBox onClick={(e) => handleDownload()} />
                    </div>
                </div>
            </div>
            <div className=''>{/* <div className='result-table-box wide'> */}</div>
        </>
    );
};

const SemesterStudentUniversityView = () => {
    const popupRef = useRef(null);
    const modalRef = useRef(null);

    return (
        <div className='body-view'>
            <section className='container'>
                <div className='container-inner'>
                    <div className='con-title-wrap conbg03'>
                        <h2 className='con-title'>{VIEW_SEMESTER_STUDENT_UNIVERSITY.title}</h2>
                        <p className='con-title-p'>{VIEW_SEMESTER_STUDENT_UNIVERSITY.subTitle}</p>
                    </div>
                    <div className='sub-nav-wrap'>
                        <BreadCrumb />
                    </div>
                    <ConditionArea popupRef={popupRef} modalRef={modalRef} />
                    <TableBox />
                </div>
            </section>
            <PopupRef ref={popupRef} />
            <ModalRef ref={modalRef} />
        </div>
    );
};

export default SemesterStudentUniversityView;
